<template>
  <div class="loading" v-show="value">
    <div id="lottie-icon" class="lottie-icon"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  watch: {
    value() {
      if (this.value) {
        this.startAnimate()
      } else {
        this.stopAnimate()
      }
    }
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: document.getElementById('lottie-icon'), // the dom element that will contain the animation
      renderer: 'svg',
      //loop: true,
      autoplay: false,
      path: 'https://gymvue.gymcity.com.cn/json/loading.json' // the path to the animation json
    })
    this.lottie.addEventListener('loopComplete', () => {
      this.lottie.goToAndPlay(500)
    })
  },
  methods: {
    stopAnimate() {
      this.lottie.stop()
    },
    startAnimate() {
      this.lottie.play()
    }
  }
}
</script>
<style scoped lang="scss">
.lottie-icon {
  width: 40px;
  height: 40px;
}
</style>
